import script from "./IconPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./IconPicker.vue?vue&type=script&setup=true&lang=js"

import "./IconPicker.vue?vue&type=style&index=0&id=66a9ad0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a9ad0a"]])

export default __exports__